import React, { useEffect } from 'react';
import { useTypedTranslation, useSetPage } from '@app/hooks';
import { getMenuItemById, hasPermission } from '@app/helpers';
import { Cloud, Help } from '@material-ui/icons';
import { mainMenuTypes, IMenuItem, mainMenuBottom } from '@app/components/Sidebar/menuObject';
import { basicService } from '@app/services/';
import { Audit } from '@app/store/constants';
import { useDispatch } from 'react-redux';
import { customBreadcrumbs } from '@app/store/actions';

const HelpPage = () => {

    const item: IMenuItem | undefined = getMenuItemById(mainMenuTypes.HelpSupport, mainMenuBottom);
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    useSetPage(null, item);

    useEffect(() => {
        dispatch(customBreadcrumbs([
            {
                name: translation('HELP_AND_SUPPORT')
            }]));
    }, [])

    return (
        <div className='help'>
            {hasPermission([Audit]) &&
                <a onClick={() => basicService.redirect('/auth/api-explorer')} className='tile help__button'>
                    <div className='help__icon'><Cloud style={{ fontSize: 60 }} /></div>
                    <div className='help__content'>
                        <h2 className='header__h2'>{translation('API_EXPLORER')}</h2>
                        <p>{translation('ACCESS_API_DOCUMENTATION')}</p>
                    </div>
                    <div className='help__arrow'>
                        <i className='icon icon-arrow'></i>
                    </div>
                </a>
            }

            <a href={basicService.getHelpUrl()} className='tile help__button' target='_blank' rel='noopener noreferrer'>
                <div className='help__icon'>
                    <Help style={{ fontSize: 60 }} />
                </div>
                <div className='help__content'>
                    <h2 className='header__h2'>{translation('HELP_AND_FEEDBACK')}</h2>
                    <p>{translation('ACCESS_HELP_AND_FEEDBACK_DOCUMENTATION')}</p>
                </div>
                <div className='help__arrow'>
                    <i className='icon icon-arrow'></i>
                </div>
            </a>
        </div>
    );
};

export default HelpPage;